import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field } from "formik";
import { BsCash } from "react-icons/bs";
import * as Yup from "yup";
import config from "../../../../config/config";
import axios from "axios";
import Select from "react-select";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { useParams } from "react-router-dom";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";

const Pricing = (props) => {
  const buttonRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [taxGroup, setTaxGroup] = useState([]);
  const [taxGroupValues, setTaxGroupValues] = useState();
  const [commissionTypeValues, setCommissionTypeValues] = useState();
  const [
    commissionPercentCalculationMethodValues,
    setCommissionPercentCalculationMethodValues,
  ] = useState();
  const [taxItemKits, setTaxItemKits] = useState([
    {
      Tax1: "",
      Tax2: "",
      Tax3: "",
      Tax4: "",
      Tax5: "",
      TaxPercentage1: "",
      TaxPercentage2: "",
      TaxPercentage3: "",
      TaxPercentage4: "",
      TaxPercentage5: "",
      Tax1Id: 0,
      Tax2Id: 0,
      Tax3Id: 0,
      Tax4Id: 0,
      Tax5Id: 0,
    },
  ]);

  const [formValues, setFormValues] = useState({
    CostPrice: "",
    SellingPrice: "",
    DisablePrice: "",
    AllowPrice: "",
    PriceTax: "",
    AllowItems: "",
    ChangePrice: "",
    Override: "",
    Commission: "",
    CommissionType: "",
    CommissionPercentCalculationMethod: "",
    OverrideTax: "",
    Tax1: "",
  });

  const [overDefaultTax, setOverDefaultTax] = useState(false);
  const [overrideDefaultCommission, setOverrideDefaultCommission] =
    useState(false);
  const [allowPrice, setAllowPrice] = useState(false);
  const [disablePrice, setDisablePrice] = useState(false);
  const [priceTax, setPriceTax] = useState(false);
  const [allowItems, setAllowItems] = useState(false);
  const [changePrice, setChangePrice] = useState(false);
  const [taxCummlative, setTaxCummlative] = useState(false);

  const [overDefaultTaxValues, setOverDefaultTaxValues] = useState(0);
  const [overrideDefaultCommissionValues, setOverrideDefaultCommissionValues] =
    useState(0);
  const [allowPriceValues, setAllowPriceValues] = useState(0);
  const [disablePriceValues, setDisablePriceValues] = useState(0);
  const [priceTaxValues, setPriceTaxValues] = useState(0);
  const [allowItemsValues, setAllowItemsValues] = useState(0);
  const [changePriceValues, setChangePriceValues] = useState(0);
  const [taxCummlativeValues, setTaxCummlativeValues] = useState(0);
  const [selectedCommissionType, setSelectedCommissionType] = useState(0);
  const [selectedCommissionPercent, setSelectedCommissionPercent] = useState(0);
  const [selectedTaxGroup, setSelectedTaxGroup] = useState(0);

  // Tax Group DropDown
  let taxGroupOptions = [];
  const TaxGroupDropDown = taxGroup.map((u, i) => {
    taxGroupOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const commissionOption = [
    { label: "Percentage", value: 1 },
    { label: "Fixed Amount", value: 2 },
  ];

  const commissionPercentCalculationMethodOption = [
    { label: "Selling Price", value: 1 },
    { label: "Profit", value: 2 },
  ];

  // Dropdown Styles
  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     // position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }), // dropdown menu css
  // };

  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  const handleChangePrice = (event) => {
    setChangePrice(!changePrice);

    if (event.target.checked === true) {
      setChangePriceValues(1);
    } else {
      setChangePriceValues(0);
    }
  };

  const handleTaxCummlative = (event) => {
    setTaxCummlative(!taxCummlative);

    if (event.target.checked === true) {
      setTaxCummlativeValues(1);
    } else {
      setTaxCummlativeValues(0);
    }
  };

  const handleAllowItems = (event) => {
    setAllowItems(!allowItems);

    if (event.target.checked === true) {
      setAllowItemsValues(1);
    } else {
      setAllowItemsValues(0);
    }
  };

  const handlePriceTax = (event) => {
    setPriceTax(!priceTax);

    if (event.target.checked === true) {
      setPriceTaxValues(1);
    } else {
      setPriceTaxValues(0);
    }
  };

  const handleDisablePrice = (event) => {
    setDisablePrice(!disablePrice);

    if (event.target.checked === true) {
      setDisablePriceValues(1);
    } else {
      setDisablePriceValues(0);
    }
  };

  const handleAllowPrice = (event) => {
    setAllowPrice(!allowPrice);

    if (event.target.checked === true) {
      setAllowPriceValues(1);
    } else {
      setAllowPriceValues(0);
    }
  };

  const handleOverDefaultTax = (event) => {
    setOverDefaultTax(!overDefaultTax);

    if (event.target.checked === true) {
      setOverDefaultTaxValues(1);
    } else {
      setOverDefaultTaxValues(0);
    }
  };

  const handleOverrideDefaultCommission = (event) => {
    setOverrideDefaultCommission(!overrideDefaultCommission);

    if (event.target.checked === true) {
      setOverrideDefaultCommissionValues(1);
    } else {
      setOverrideDefaultCommissionValues(0);
    }
  };

  const handleChangeForValues = (event) => {
    let name, values;

    name = event.target.name;
    values = event.target.value;

    let cardInput = taxItemKits;

    if (cardInput) {
      cardInput[name] = values;

      setTaxItemKits(cardInput);
    }
  };

  const handleDropDown = (event, fieldName) => {
    let values;
    values = event.value;

    if (fieldName === "TaxGroup") {
      setTaxGroupValues(values);
    } else if (fieldName === "Commissiontype") {
      setCommissionTypeValues(values);
    } else if (fieldName === "CommissionPercentCalculationMethod") {
      setCommissionPercentCalculationMethodValues(values);
    }
  };

  const validationSchema = Yup.object().shape({
    CostPrice: Yup.number().required("Cost Price is required"),
    SellingPrice: Yup.number().required("Selling Price is required"),
  });

  // for calculation of selling and cost price
  const handleCalculation = (values, itemkitid, pricetype, setFieldValue) => {
    axios
      .get(
        `${config.itemKitsBaseUrl}/itemkits/pricingcalculation?itemkitid=${itemkitid}&pricetype=${pricetype}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const calculatedPrice =
          pricetype === 0
            ? response.data.ResponseData[0].CostPrice
            : response.data.ResponseData[0].SellingPrice;
        setFieldValue(
          pricetype === 0 ? "CostPrice" : "SellingPrice",
          parseFloat(calculatedPrice)
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //pricing data insert
  const handleSubmit = (values) => {
    let tax = taxGroupOptions.find((options) => {
      return options.value == selectedTaxGroup;
    });

    const result = [];
    let obj = taxItemKits;

    for (let i = 1; i <= 5; i++) {
      const taxName = obj[`Tax${i}`];
      const taxPercentage = obj[`TaxPercentage${i}`];
      const taxID = obj[`Tax${i}Id`] == undefined ? 0 : obj[`Tax${i}Id`];
      result.push({
        TaxId: taxID,
        TaxName: taxName,
        TaxPercent: taxPercentage,
        TaxCumulative: taxCummlativeValues,
      });
    }

    // To filter all null values of Location data
    let TaxPricing = result.filter(function (taxPricing) {
      return taxPricing.TaxName !== "";
    });

    // XML object declare
    const taxpricingobj = {};

    // After filtering the array to set to particular object
    taxpricingobj.itemkitstaxxml = TaxPricing;

    // Object are converted to JSON string
    let taxpricingjsonstring = JSON.stringify(taxpricingobj);

    const postingdata = {
      xmlitemkitstax: taxpricingjsonstring,
      itemkitid: paramObject.id || 0,
      costprice: values.CostPrice,
      unitprice: values.SellingPrice,
      disablefrompricerules: disablePriceValues,
      allowpriceoverrideregardlessofpermissions: allowPriceValues,
      taxincluded: priceTaxValues,
      allowitemstobesoldinwholenumbers: allowItemsValues,
      changecostprice: changePriceValues,
      commission: values.Commission,
      commissiontype: commissionTypeValues,
      overridedefaultcommission: overrideDefaultCommissionValues,
      commissionpercentcalculationmethod:
        commissionPercentCalculationMethodValues,
      overridedefaulttax: overDefaultTaxValues,
      taxgroup: taxGroupValues,
      loginuserid: Id,
    };
    console.log("postingdata ===>", postingdata);
    // Pricing Upsert API Call
    axios
      .post(`${config.itemKitsBaseUrl}/itemkits/pricingupsert`, postingdata, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
        props.nextStep();
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error: ", error);
      });
  };

  //binding pricing all data
  useEffect(() => {
    //  Binding TaxGroup DropDown
    axios
      .get(`${config.generalBaseUrl}/generals/taxesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTaxGroup(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("error: " + err);
      });

    //binding pricing fields

    if (paramObject.id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/pricingfindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData);
          const pricingdata = res.data.ResponseData.ItemKits[0];

          // For biniding the dropdown
          setSelectedCommissionType(
            res.data.ResponseData.ItemKits[0].Commissiontype
          );
          setSelectedCommissionPercent(
            res.data.ResponseData.ItemKits[0].CommissionPercentCalculationMethod
          );

          setSelectedTaxGroup(res.data.ResponseData.ItemKits[0].TaxGroup);
          setTaxGroupValues(res.data.ResponseData.ItemKits[0].TaxGroup);
          // For updating the data of drop down
          setCommissionPercentCalculationMethodValues(
            res.data.ResponseData.ItemKits[0].CommissionPercentCalculationMethod
          );
          setCommissionTypeValues(
            res.data.ResponseData.ItemKits[0].Commissiontype
          );

          // For handling all the check boxs
          setAllowPriceValues(
            pricingdata.Allowpriceoverrideregardlessofpermissions === 1 ? 1 : 0
          );
          setChangePriceValues(pricingdata.Changecostprice === 1 ? 1 : 0);
          setAllowItemsValues(
            pricingdata.Allowitemstobesoldinwholenumbers === 1 ? 1 : 0
          );
          setPriceTaxValues(pricingdata.TaxIncluded === 1 ? 1 : 0);
          setDisablePriceValues(
            pricingdata.Disablefrompricerules === 1 ? 1 : 0
          );
          setOverrideDefaultCommissionValues(
            pricingdata.Overridedefaultcommission === 1 ? 1 : 0
          );
          setOverDefaultTaxValues(pricingdata.Overridedefaulttax === 1 ? 1 : 0);

          const data = {
            CostPrice: parseFloat(pricingdata.Costprice),
            SellingPrice: parseFloat(pricingdata.Unitprice),
            DisablePrice: pricingdata.Disablefrompricerules,
            AllowPrice: pricingdata.Allowpriceoverrideregardlessofpermissions,
            PriceTax: pricingdata.TaxIncluded,
            AllowItems: pricingdata.Allowitemstobesoldinwholenumbers,
            ChangePrice: pricingdata.Changecostprice,
            Override: pricingdata.Overridedefaultcommission,
            Commission: parseFloat(pricingdata.Commission),
            Commissiontype: pricingdata.Commissiontype,
            CommissionPercentCalculationMethod:
              pricingdata.CommissionPercentCalculationMethod,
            OverrideTax: pricingdata.Overridedefaulttax,
            TaxGroup: pricingdata.TaxGroup,
          };
          setFormValues(data);

          const taxdata = {
            Tax1: res.data.ResponseData.Itemkitstaxes[0].Name,
            Tax2: res.data.ResponseData.Itemkitstaxes[1].Name,
            Tax3: res.data.ResponseData.Itemkitstaxes[2].Name,
            Tax4: res.data.ResponseData.Itemkitstaxes[3].Name,
            Tax5: res.data.ResponseData.Itemkitstaxes[4].Name,
            TaxPercentage1: parseFloat(
              res.data.ResponseData.Itemkitstaxes[0].Percent
            ),
            TaxPercentage2: parseFloat(
              res.data.ResponseData.Itemkitstaxes[1].Percent
            ),
            TaxPercentage3: parseFloat(
              res.data.ResponseData.Itemkitstaxes[2].Percent
            ),
            TaxPercentage4: parseFloat(
              res.data.ResponseData.Itemkitstaxes[3].Percent
            ),
            TaxPercentage5: parseFloat(
              res.data.ResponseData.Itemkitstaxes[4].Percent
            ),
            Tax1Id: res.data.ResponseData.Itemkitstaxes[0].Id,
            Tax2Id: res.data.ResponseData.Itemkitstaxes[1].Id,
            Tax3Id: res.data.ResponseData.Itemkitstaxes[2].Id,
            Tax4Id: res.data.ResponseData.Itemkitstaxes[3].Id,
            Tax5Id: res.data.ResponseData.Itemkitstaxes[4].Id,
          };
          setTaxCummlativeValues(
            res.data.ResponseData.Itemkitstaxes[4].Cumulative
          );
          setTaxItemKits(taxdata);
          setTaxCummlative(res.data.ResponseData.Itemkitstaxes[0].Cumulative);

          // For checking of the check box
          setAllowPrice(
            pricingdata.Allowpriceoverrideregardlessofpermissions === 1
              ? true
              : false
          );
          setChangePrice(pricingdata.Changecostprice === 1 ? true : false);
          setAllowItems(
            pricingdata.Allowitemstobesoldinwholenumbers === 1 ? true : false
          );
          setPriceTax(pricingdata.TaxIncluded === 1 ? true : false);
          setDisablePrice(
            pricingdata.Disablefrompricerules === 1 ? true : false
          );
          setOverrideDefaultCommission(
            pricingdata.Overridedefaultcommission === 1 ? true : false
          );
          setOverDefaultTax(
            pricingdata.Overridedefaulttax === 1 ? true : false
          );
        })
        .catch((err) => {
          console.log("error: ", err);
        });
    }
  }, []);

  // const handleNext = () => {
  //   props.nextStep();
  //   handleSubmit();
  //   window.scrollTo(0, 0);
  // };

  function handleButtonClick() {
    if (buttonRef.current.getAttribute("data-page") === "specific-page") {
      buttonRef.current.click();
      console.log("Button 1 clicked and Button 2 triggered");
    }
  }

  return (
    <>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title">
            <BsCash className="me-1" />
            Pricing (Fields in <span className="text-danger">*</span> are
            required)
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-primary btn-md me-1"
              >
                Back
              </button>
            )}
            {props.currentStep < props.totalSteps && (
              <button
                //onClick={handleNext}
                className="btn btn-primary btn-md"
                type="button"
                onClick={handleButtonClick}
              >
                Next
              </button>
            )}
          </div>
        </div>
        <Formik
          {...props}
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, handleChange, values, setFieldValue }) => (
            <Form className="px-4">
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        <label>
                          {" "}
                          Cost Price (Without Tax)
                          <span className="text-danger">*</span>
                        </label>

                        <div className="input-group mb-3">
                          <span className="input-group-text">$</span>
                          <Field
                            type="text"
                            className={`form-control ${
                              errors.CostPrice ? "is-invalid" : ""
                            }`}
                            id="CostPrice"
                            name="CostPrice"
                            onChange={handleChange}
                          />
                          <span class="input-group-text input-group-btn bg">
                            <button
                              id="calc_cost_price"
                              class="btn btn-default"
                              type="button"
                              onClick={() =>
                                handleCalculation(
                                  values,
                                  paramObject.id,
                                  0,
                                  setFieldValue
                                )
                              }
                            >
                              <i class="fas fa-solid fa-calculator me-1"></i>
                              Calculate Suggested Price
                            </button>
                          </span>
                        </div>
                        <div className="invalid-feedback">
                          {touched.CostPrice && errors.CostPrice
                            ? errors.CostPrice
                            : ""}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label>
                          {" "}
                          Selling Price (Without Tax)
                          <span className="text-danger">*</span>
                        </label>

                        <div className="input-group mb-3">
                          <span className="input-group-text">$</span>
                          <Field
                            type="text"
                            className={`form-control ${
                              errors.SellingPrice ? "is-invalid" : ""
                            }`}
                            id="SellingPrice"
                            name="SellingPrice"
                            onChange={handleChange}
                          />
                          <span class="input-group-text input-group-btn bg">
                            <button
                              id="calc_cost_price"
                              class="btn btn-default"
                              type="button"
                              onClick={() =>
                                handleCalculation(
                                  values,
                                  paramObject.id,
                                  1,
                                  setFieldValue
                                )
                              }
                            >
                              <i class="fas fa-solid fa-calculator me-1"></i>
                              Calculate Suggested Price
                            </button>
                          </span>
                        </div>
                        <div className="invalid-feedback">
                          {touched.SellingPrice && errors.SellingPrice
                            ? errors.SellingPrice
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mt-3">
                      <Field
                        type="checkbox"
                        style={{ width: "1.25em", height: "1.25em" }}
                        className="checkbox form-check-input me-3"
                        id="DisablePrice"
                        name="DisablePrice"
                        checked={disablePrice}
                        onChange={(event) => {
                          handleDisablePrice(event);
                        }}
                      />
                      <label className="form-check-label">
                        Disable From Price Rules
                      </label>
                    </div>

                    <div className="mt-3">
                      <Field
                        type="checkbox"
                        style={{ width: "1.25em", height: "1.25em" }}
                        className="checkbox form-check-input me-3"
                        id="PriceTax"
                        name="PriceTax"
                        checked={priceTax}
                        onChange={(event) => {
                          handlePriceTax(event);
                        }}
                      />
                      <label className="form-check-label me-3">
                        Prices Include Tax
                      </label>
                    </div>

                    <div className="mt-3">
                      <Field
                        type="checkbox"
                        style={{ width: "1.25em", height: "1.25em" }}
                        className="checkbox form-check-input me-3"
                        id="AllowPrice"
                        name="AllowPrice"
                        checked={allowPrice}
                        onChange={(event) => {
                          handleAllowPrice(event);
                        }}
                      />
                      <label className="form-check-label me-3">
                        Allow Price Override Regardless Of Permissions
                      </label>
                    </div>

                    <div className="mt-3">
                      <Field
                        type="checkbox"
                        style={{ width: "1.25em", height: "1.25em" }}
                        className="checkbox form-check-input me-3"
                        id="AllowItems"
                        name="AllowItems"
                        checked={allowItems}
                        onChange={(event) => {
                          handleAllowItems(event);
                        }}
                      />
                      <label className="form-check-label me-3">
                        Only Allow Items To Be Sold In Whole Numbers
                      </label>
                    </div>

                    <div className="mt-3">
                      <Field
                        type="checkbox"
                        style={{ width: "1.25em", height: "1.25em" }}
                        className="checkbox form-check-input me-3"
                        id="ChangePrice"
                        name="ChangePrice"
                        checked={changePrice}
                        onChange={(event) => {
                          handleChangePrice(event);
                        }}
                      />
                      <label className="form-check-label me-3">
                        Change Cost Price During Sale
                      </label>
                    </div>
                  </div>
                </div>

                {/* On checkbox open the area Commission*/}
                <div className="col-md-8 mb-3">
                  <Field
                    type="checkbox"
                    style={{ width: "1.25em", height: "1.25em" }}
                    className="checkbox form-check-input me-3"
                    id="Override"
                    name="Override"
                    checked={overrideDefaultCommission}
                    onChange={(event) => {
                      handleOverrideDefaultCommission(event);
                    }}
                  />
                  <label className="form-check-label me-3">
                    Override Default Commission
                  </label>
                </div>
                {overrideDefaultCommission && (
                  <>
                    <div className="row">
                      <div className="col-md-2 mb-3">
                        <label className="">Commission: </label>
                      </div>
                      <div className="col-md-3">
                        <Field
                          type="number"
                          className="form-control"
                          id="Commission"
                          name="Commission"
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-4 mb-2">
                        <Select
                          onChange={(event) => {
                            handleDropDown(event, "Commissiontype");
                          }}
                          defaultValue={
                            commissionOption.find(
                              (option) =>
                                option.value === selectedCommissionType
                            ) || ""
                          }
                          options={commissionOption}
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          isClearable={true}
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          id="Commissiontype"
                          name="Commissiontype"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5 mt-2">
                        <label className="">
                          Commission Percent Calculation Method:
                        </label>
                      </div>
                      <div className="col-md-4 mt-1">
                        <Select
                          onChange={(event) => {
                            handleDropDown(
                              event,
                              "CommissionPercentCalculationMethod"
                            );
                          }}
                          defaultValue={
                            commissionPercentCalculationMethodOption.find(
                              (option) =>
                                option.value === selectedCommissionPercent
                            ) || ""
                          }
                          options={commissionPercentCalculationMethodOption}
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          isClearable={true}
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          id=" CommissionPercentCalculationMethod"
                          name="CommissionPercentCalculationMethod"
                        />
                      </div>
                    </div>
                    <div className="mb-3"></div>
                  </>
                )}

                {/* On checkbox open the area Tax*/}
                <div className="col-md-8 mb-3">
                  <Field
                    type="checkbox"
                    style={{ width: "1.25em", height: "1.25em" }}
                    className="checkbox form-check-input me-3 mb-2"
                    id="OverrideTax"
                    name="OverrideTax"
                    checked={overDefaultTax}
                    onChange={(event) => {
                      handleOverDefaultTax(event);
                    }}
                  />
                  <label className="form-check-label me-3">
                    Override Default Tax
                  </label>
                </div>
                {overDefaultTax && (
                  <>
                    <div className="row">
                      <div className="col-md-2 mt-2">
                        <label className="align-center">Tax Group:</label>
                      </div>
                      <div className="col-md-10 mb-3">
                        <span>selectedTaxGroup: {selectedTaxGroup}</span>
                        <Select
                          onChange={(event) => {
                            handleDropDown(event, "TaxGroup");
                          }}
                          defaultValue={taxGroupOptions.find(
                            (obj) => obj.value == selectedTaxGroup
                          )}
                          options={taxGroupOptions}
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          isClearable={true}
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          id="TaxGroup"
                          name="TaxGroup"
                        />
                      </div>
                      <h4 className="col-md-12 align-center">OR</h4>
                      <div className="row mt-2">
                        <div className="col-md-2">
                          <label className="align-center mt-2">Tax 1</label>
                        </div>
                        <div className="col-md-2 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="Tax1"
                            name="Tax1"
                            defaultValue={taxItemKits.Tax1}
                            onChange={(event) => handleChangeForValues(event)}
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <div className="input-group mb-3">
                            <input
                              type="number"
                              className="form-control"
                              id="TaxPercentage1"
                              name="TaxPercentage1"
                              defaultValue={taxItemKits.TaxPercentage1}
                              onChange={(event) => handleChangeForValues(event)}
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <label className="align-center mt-2">Tax 2</label>
                        </div>
                        <div className="col-md-2 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="Tax2"
                            name="Tax2"
                            defaultValue={taxItemKits.Tax2}
                            onChange={(event) => handleChangeForValues(event)}
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <div className="input-group mb-3">
                            <input
                              type="number"
                              className="form-control"
                              id="TaxPercentage2"
                              name="TaxPercentage2"
                              defaultValue={taxItemKits.TaxPercentage2}
                              onChange={(event) => handleChangeForValues(event)}
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-2">
                          <label className="align-center mt-2">Tax 3</label>
                        </div>
                        <div className="col-md-2 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="Tax3"
                            name="Tax3"
                            defaultValue={taxItemKits.Tax3}
                            onChange={(event) => handleChangeForValues(event)}
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <div className="input-group mb-3">
                            <input
                              type="number"
                              className="form-control"
                              id="TaxPercentage3"
                              name="TaxPercentage3"
                              defaultValue={taxItemKits.TaxPercentage3}
                              onChange={(event) => handleChangeForValues(event)}
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <label className="align-center mt-2">Tax 4</label>
                        </div>
                        <div className="col-md-2 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="Tax4"
                            name="Tax4"
                            defaultValue={taxItemKits.Tax4}
                            onChange={(event) => handleChangeForValues(event)}
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <div className="input-group mb-3">
                            <input
                              type="number"
                              className="form-control"
                              id="TaxPercentage4"
                              name="TaxPercentage4"
                              defaultValue={taxItemKits.TaxPercentage4}
                              onChange={(event) => handleChangeForValues(event)}
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-2">
                          <label className="align-center mt-2">Tax 5</label>
                        </div>
                        <div className="col-md-2 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="Tax5"
                            name="Tax5"
                            defaultValue={taxItemKits.Tax5}
                            onChange={(event) => handleChangeForValues(event)}
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <div className="input-group mb-3">
                            <input
                              type="number"
                              className="form-control"
                              id="TaxPercentage5"
                              name="TaxPercentage5"
                              defaultValue={taxItemKits.TaxPercentage5}
                              onChange={(event) => handleChangeForValues(event)}
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                        <div className="col-md-4 ms-4">
                          <Field
                            type="checkbox"
                            style={{ width: "1.25em", height: "1.25em" }}
                            className="checkbox form-check-input me-3"
                            id="TaxCummlative"
                            name="TaxCummlative"
                            checked={taxCummlative}
                            onChange={(event) => {
                              handleTaxCummlative(event);
                            }}
                          />
                          <label className="form-check-label">
                            Tax Cummlative
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Next and Back Button */}
              <div className="text-center mb-4 mt-4">
                {props.currentStep > 1 && (
                  <button
                    type="button"
                    onClick={handleBack}
                    className="btn btn-primary me-3"
                  >
                    Back
                  </button>
                )}
                {props.currentStep < props.totalSteps && (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    data-page="specific-page"
                    ref={buttonRef}
                  >
                    Next
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};
export default Pricing;
